import { render, staticRenderFns } from "./purchasesReturnsEdit_v3.vue?vue&type=template&id=abf82766&scoped=true&"
import script from "./purchasesReturnsEdit_v3.vue?vue&type=script&lang=js&"
export * from "./purchasesReturnsEdit_v3.vue?vue&type=script&lang=js&"
import style0 from "./purchasesReturnsEdit_v3.vue?vue&type=style&index=0&id=abf82766&lang=less&scoped=true&"
import style1 from "./purchasesReturnsEdit_v3.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf82766",
  null
  
)

component.options.__file = "purchasesReturnsEdit_v3.vue"
export default component.exports